export default __webpack_public_path__ + "static/media/BannerDesk.d9ceab8e.jpg";